import { FormNames, IFormDefinition } from '../../models/form/IFormDefinition'
import { basicInfoFields, basicInfoFormValidations } from '../BasicInfo/BasicInfoFields'
import { AppLinks } from '../../environment/app-links'

export const basicInfoForm: IFormDefinition = {
   name: FormNames.BasicInfoForm, 
   fields: basicInfoFields,
   urlPath: AppLinks.basicInfoForm,
   nextFormUrlPath: AppLinks.extendedInfoForm,
   canStepBackInForm: false,
   formValidationFunctions: basicInfoFormValidations,
}